<template>
  <div class="ticket-loader w-100 h-100 fixed top-0">
    <div class="ticket-loader-inner-content fixed left-0 right-0 flex middle-xs center-xs flex-column">
      <h5 class="c-white mt0 mb10 mb20-desktop regular italic">
        {{ $t(ticketLoaderMessage) }}
      </h5>
      <i class="icon icon-ticket" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      openTicketLoader: state => state.ui.openTicketLoader,
      ticketLoaderMessage: state => state.ui.ticketLoaderMessage
    }),
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';
@import '~theme/css/helpers/functions/z-index-selectors';
@import '~theme/css/variables/grid';

.ticket-loader {
  z-index: zIndex(popup);
  background-color: rgba(color(black), 0.8);

  &-inner-content {
    top: 140px;

    i {
      width: 143px;
      height: 53px;
    }
  }
}

@include desktop {
  .ticket-loader {
    &-inner-content {
      top: 215px;

      i {
        width: 337px;
        height: 125px;
      }
    }
  }
}
</style>
